<template>
    <div class="redirect-auth">
        <loader-full></loader-full>
    </div>
</template>
<script>
import LoaderFull from '../components/Loaders/LoaderFull.vue'
import middleware from './middleware.js'
var moment = require('moment')
moment.locale('pt-br');
export default {
    components : {
        LoaderFull
    },
    computed: {
        variables(){
            return this.$store.getters.allVariables
        }
    },
    async created(){
        localStorage.clear()
        const { token, workspaceId } = this.$route.query
        const userId = this.$route.query.uid
        // console.log(this.$route.query)
        const player = await this.getSavePlayer(userId)
        localStorage.setItem("player", JSON.stringify(player))
        // console.log(player)
        const workspace = await middleware.getWorkspace(workspaceId)
        const workspaceTitle = workspace.title
        // console.log("title: ", workspace.title)
        // console.log("colors: ", workspace.colors)
        // let defaultColor = {
        //     primary: "#58fdf4",
        //     secondary: "#3F7CAC",
        //     theme: "dark",
        //     clientLogoPath: "",
        //     dark: {
        //         to: "#192733",
        //         from: "#001324",
        //     },
        //     light: {
        //         to: "#fff",
        //         from: "#ccc",
        //     },                
        // }
        // let colors = workspace.colors ? workspace.colors : defaultColor
        // if(!colors.theme) colors.theme = 'dark'
        localStorage.setItem("colors", JSON.stringify(await this.getCustomColors(workspaceId)));        
        await this.$store.dispatch('simpleSave', {
            token,
            userId,
            workspaceId,
            workspaceTitle,
            player
        })
        await this.redirectGame(token, userId, workspaceId)
    },
    methods: {
        async getCustomColors(workspaceId){
            // console.log('Chegou no getCustomColors()')
            let colors = {
                primary: "#58fdf4",
                secondary: "#3F7CAC",
                theme: "dark",
                clientLogoPath: "",
                dark: {
                    to: "#192733",
                    from: "#001324",
                },
                light: {
                    to: "#fff",
                    from: "#ccc",
                },  
            }
            try {
                // console.log("before get wsSetups")
                const responseSetups = await this.$http.get(`${process.env.VUE_APP_SERVICE_CATALOG}/ws-setups/?workspaceId=${workspaceId}`);
                // console.log("responseSetups: ", responseSetups)
                if (!responseSetups.data.wsSetups.fields || !responseSetups.data.wsSetups.fields.products || !responseSetups.data.wsSetups.fields.products.decode) return colors
                if (responseSetups.data.wsSetups.fields.products.decode.colors)
                    colors = {
                        ...colors, 
                        ...responseSetups.data.wsSetups.fields.products.decode.colors,
                        theme: responseSetups.data.wsSetups.fields.products.decode.theme || 'dark',
                        clientLogoPath: responseSetups.data.wsSetups.fields.products.decode.logoPath
                    }
            } catch (error) {
                return colors
            }
            return colors
        },
        async redirectGame(token, userId, workspaceId){
            
            if(!await middleware.verifyAuth(token)) return middleware.redirectAuth() 

            let statusSchedule = await middleware.verifySchedule(userId, workspaceId)
            if(statusSchedule.sessionId){
                this.$store.dispatch('simpleSave', {
                    "sessionId" : statusSchedule.sessionId
                })
            }
            this.$router.push({ name : statusSchedule.name, params : { status : statusSchedule.status, scheduleTime : statusSchedule.schedule }})
        },
        async getSavePlayer(userId){
            const player = await middleware.getPlayerInfo(userId)
            return player
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
